import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getWorkflowCase,
  listWorkflowCases,
  updateSubStepMemo,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * サブステップのメモを追加・編集・削除する mutation hook (spec AC-005b、
 * workflow-substep-memo design)。即時保存、optimistic update なし
 * (useToggleSubStep と同じ簡潔な実装方針)。
 * onSuccess で detail + list query を invalidate する。
 */
export function useUpdateSubStepMemo(
  caseId: string,
): InvalidatingMutationResultFor<typeof updateSubStepMemo> {
  return useInvalidatingMutation(updateSubStepMemo, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
